import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5 text-primary-900 group-aria-expanded:text-primary-300 group-hover:text-primary-300" }
const _hoisted_2 = { key: 0 }

import Dropdown from '../navigation/Dropdown.vue';
import IconArrowDown from '../icons/IconArrowDown.vue';
import { DropdownOptionType } from '~src/admin/types';
import { computed, ref, watchEffect } from 'vue';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'Status',
  emits: ["updateActiveStatus"],
  setup(__props, { expose: __expose, emit: __emit }) {

const { $gettext } = useGettext();

// Emits
const emit = __emit;

// Status dropdown options
const statusOptions = ref<DropdownOptionType[]>([
    {
        label: $gettext('Scheduled to be generated'),
        selected: false,
    },
    {
        label: $gettext('Scheduled for publication'),
        selected: false,
    },
    {
        label: $gettext('Published'),
        selected: false,
    },
]);

// Select a status option
const updateStatus = (label: string) => {
    // Change the selected value to opposite
    statusOptions.value.map((option) => {
        if (option.label === label) {
            option.selected = !option.selected;
        }
        return option;
    });
};

__expose({
    updateStatus,
});

// Calculate number of selected options
const numberOfSelectedOptions = computed(() => {
    return statusOptions.value.reduce((count, option) => {
        return option.selected ? count + 1 : count;
    }, 0);
});

// Whenever statusOptions changes update the parent component
watchEffect(() => {
    const activeStatus = statusOptions.value.filter((status) => status.selected).map((status) => status.label);
    emit('updateActiveStatus', activeStatus);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dropdown, {
    options: statusOptions.value,
    "menu-width": "wide",
    onSelectOption: _cache[0] || (_cache[0] = (label) => updateStatus(label))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_unref($gettext)('Status')) + " ", 1),
          (numberOfSelectedOptions.value !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(`(${numberOfSelectedOptions.value})`), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(IconArrowDown, { class: "transition-transform group-aria-expanded:rotate-180 group-hover:rotate-180" })
      ])
    ]),
    _: 1
  }, 8, ["options"]))
}
}

})